// extracted by mini-css-extract-plugin
export default {"label":"penalizedFilterLabel-module__label__6Wj43"};